import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { envConfig, environment } from './environments/environment';
import { EnvironmentHostEnum } from './environments/environment.interface';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: envConfig.sentry.dsn,
  debug: envConfig.sentry.debug,
  environment: envConfig.name,
  sendDefaultPii: true,
  maxBreadcrumbs: envConfig.sentry.maxBreadcrumbs,
  attachStacktrace: true,
  enabled: envConfig.sentry.enabled,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['error'] }),
  ],
  sampleRate: envConfig.sentry.sampleRate,
  replaysSessionSampleRate: envConfig.sentry.replaysSessionSampleRate,
  replaysOnErrorSampleRate: envConfig.sentry.replaysOnErrorSampleRate,
  tracesSampleRate: envConfig.sentry.tracesSampleRate,
  tracePropagationTargets: Object.values(EnvironmentHostEnum),
  enableLogs: true,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
